<template>
    <div class="chart-container">
        <LineChart :data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import LineChart from "./LineChart";

export default {
    name: "week-rooms-chart",
    components: {
        LineChart,
    },
    props: {
        data: {
            type: Array,
        },
        labels: {
            type: Array,
        },
    },
    data() {
        return {
            chartData: {
                labels: this.labels,
                datasets: [
                    {
                        data: this.data,
                        fill: true,
                        borderWidth: 4,
                        backgroundColor: "rgba(0, 100, 173, 0.5)",
                        tension: 0,
                    },
                ],
            },
            chartOptions: {
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                display: true,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                display: true,
                            },
                        },
                    ],
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: "right",
                },
            },
        };
    },
    mounted() {
        this.chartData.datasets[0].data = this.data;
    },
};
</script>

<style lang="scss" scoped>
.chart-container {
    > div {
        height: 300px;
    }
}
</style>